import React, { useState } from "react";
import { aiChat } from "../api";

var h = React.createElement;
var PRIMARY = "#7c3aed";
var TEXT = "#181818";
var TEXT3 = "#9ca3af";
var BORDER = "#e5e7eb";
var BG = "#fafafa";
var WHITE = "#fff";
var SHADOW = "0 1px 3px rgba(0,0,0,0.06)";
var SHADOW_LG = "0 4px 16px rgba(0,0,0,0.10)";
var card3d = {
  background: "linear-gradient(135deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,0.68) 100%)",
  backdropFilter: "blur(34px) saturate(180%)",
  WebkitBackdropFilter: "blur(34px) saturate(180%)",
  border: "1px solid rgba(255,255,255,0.40)",
  boxShadow: "0 1px 0 rgba(255,255,255,0.70) inset, 0 18px 44px -18px rgba(11,107,211,0.28), 0 8px 24px -10px rgba(14,165,233,0.18)",
  borderRadius: 18,
  padding: 20
};

var funnelStages = [
  { key: "awareness", label: "Awareness", sub: "Get Discovered", color: "#7c3aed", kpis: ["Impressions", "CPM", "Video Views"], budget: 25, creative: "Entertaining, funny, shareable" },
  { key: "consideration", label: "Consideration", sub: "Build Interest", color: "#2563eb", kpis: ["CTR", "CPC", "Leads"], budget: 35, creative: "Educational, social proof" },
  { key: "conversion", label: "Conversion", sub: "Drive Sales", color: "#059669", kpis: ["ROAS", "CPA", "Revenue"], budget: 30, creative: "Direct offers, urgency" },
  { key: "loyalty", label: "Loyalty", sub: "Keep Customers", color: "#dc2626", kpis: ["LTV", "Repeat Rate", "Referrals"], budget: 10, creative: "Community, VIP, appreciation" }
];

function BarChart(props) {
  var data = props.data; var width = props.width || 320; var height = props.height || 180;
  var maxVal = Math.max.apply(null, data.map(function(d) { return d.value; }));
  var barW = Math.floor((width - 60) / data.length) - 8;
  var bars = data.map(function(d, i) {
    var barH = Math.max(4, (d.value / maxVal) * (height - 50));
    return h("g", { key: i },
      h("rect", { x: 40 + i * (barW + 8), y: height - 30 - barH, width: barW, height: barH, rx: 4, fill: d.color || PRIMARY, opacity: 0.85 }),
      h("text", { x: 40 + i * (barW + 8) + barW / 2, y: height - 10, textAnchor: "middle", fontSize: 11, fill: TEXT3 }, d.label),
      h("text", { x: 40 + i * (barW + 8) + barW / 2, y: height - 35 - barH, textAnchor: "middle", fontSize: 11, fontWeight: 600, fill: TEXT }, d.value + "%")
    );
  });
  return h("svg", { width: width, height: height, style: { display: "block", margin: "0 auto" } }, bars);
}

function DonutChart(props) {
  var data = props.data; var size = props.size || 160;
  var cx = size / 2; var cy = size / 2; var r = size / 2 - 20; var strokeW = 22;
  var total = data.reduce(function(s, d) { return s + d.value; }, 0);
  var offset = 0;
  var arcs = data.map(function(d, i) {
    var pct = d.value / total;
    var dashLen = 2 * Math.PI * r * pct;
    var dashGap = 2 * Math.PI * r * (1 - pct);
    var dashOff = -2 * Math.PI * r * offset;
    offset += pct;
    return h("circle", { key: i, cx: cx, cy: cy, r: r, fill: "none", stroke: d.color, strokeWidth: strokeW, strokeDasharray: dashLen + " " + dashGap, strokeDashoffset: dashOff, strokeLinecap: "round", style: { transition: "all 0.5s ease" } });
  });
  return h("svg", { width: size, height: size, style: { transform: "rotate(-90deg)" } }, arcs);
}

function ObjectiveSelector() {
  var _s1 = useState("overview"); var tab = _s1[0]; var setTab = _s1[1];
  var _s2 = useState(null); var recs = _s2[0]; var setRecs = _s2[1];
  var _s3 = useState(false); var loading = _s3[0]; var setLoading = _s3[1];
  var _s4 = useState([]); var goals = _s4[0]; var setGoals = _s4[1];
  var _s5 = useState(""); var goalText = _s5[0]; var setGoalText = _s5[1];
  var _s6 = useState("awareness"); var selStage = _s6[0]; var setSelStage = _s6[1];

  var getRecs = function() {
    setLoading(true); setRecs(null);
    aiChat("Based on a typical marketing funnel with Awareness, Consideration, Conversion, and Loyalty stages, give me 5 specific actionable recommendations for improving campaign performance across all stages. Be concise. Number each recommendation.").then(function(d) {
      setRecs((d && d.reply) || "Unable to get recommendations right now."); setLoading(false);
    }).catch(function() {
      setRecs("Connect to the internet and try again."); setLoading(false);
    });
  };

  var addGoal = function() {
    if (!goalText.trim()) return;
    setGoals(function(p) { return p.concat([{ id: Date.now(), text: goalText.trim(), stage: selStage, done: false }]); });
    setGoalText("");
  };

  var toggleGoal = function(id) {
    setGoals(function(p) { return p.map(function(g) { return g.id === id ? Object.assign({}, g, { done: !g.done }) : g; }); });
  };

  var tabs = [
    { id: "overview", label: "Overview" },
    { id: "goals", label: "Goals" },
    { id: "recommendations", label: "AI Recommendations" }
  ];

  var budgetData = funnelStages.map(function(s) { return { label: s.label.substring(0, 5), value: s.budget, color: s.color }; });
  var donutData = funnelStages.map(function(s) { return { value: s.budget, color: s.color }; });

  return h("div", null,
    h("h2", { style: { fontSize: 24, fontWeight: 700, color: TEXT, marginBottom: 4, letterSpacing: "-0.022em" } }, "Objectives"),
    h("p", { style: { color: TEXT3, fontSize: 14, marginBottom: 20 } }, "Vella tailors targeting, budget, creative style, and KPIs based on your funnel stage."),

    h("div", { style: { display: "flex", gap: 4, marginBottom: 24, flexWrap: "wrap" } },
      tabs.map(function(t) {
        return h("button", { key: t.id, onClick: function() { setTab(t.id); }, style: { padding: "8px 18px", borderRadius: 999, border: tab === t.id ? "none" : "1px solid rgba(255,255,255,0.45)", background: tab === t.id ? PRIMARY : WHITE, color: tab === t.id ? WHITE : TEXT, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all 0.2s" } }, t.label);
      })
    ),

    tab === "overview" && h("div", null,
      h("div", { style: { display: "flex", gap: 16, marginBottom: 24, flexWrap: "wrap" } },
        h("div", { style: Object.assign({}, card3d, { flex: "1 1 320px", minWidth: 280 }) },
          h("h3", { style: { fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 16 } }, "Budget Allocation"),
          h(BarChart, { data: budgetData, width: 320, height: 180 })
        ),
        h("div", { style: Object.assign({}, card3d, { flex: "0 0 220px", display: "flex", flexDirection: "column", alignItems: "center" }) },
          h("h3", { style: { fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 12 } }, "Funnel Split"),
          h(DonutChart, { data: donutData, size: 150 }),
          h("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12, justifyContent: "center" } },
            funnelStages.map(function(s) {
              return h("div", { key: s.key, style: { display: "flex", alignItems: "center", gap: 4, fontSize: 11 } },
                h("div", { style: { width: 8, height: 8, borderRadius: "50%", background: s.color } }),
                h("span", { style: { color: TEXT3 } }, s.label)
              );
            })
          )
        )
      ),

      h("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 } },
        funnelStages.map(function(s) {
          return h("div", { key: s.key, style: Object.assign({}, card3d, { borderLeft: "4px solid " + s.color }) },
            h("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 } },
              h("svg", { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: s.color, strokeWidth: 2 },
                h("circle", { cx: 12, cy: 12, r: 10 }),
                h("path", { d: "M12 8v4l2 2" })
              ),
              h("span", { style: { fontSize: 11, fontWeight: 700, color: s.color, textTransform: "uppercase", letterSpacing: 1 } }, s.label)
            ),
            h("h4", { style: { fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 4 } }, s.sub),
            h("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 10, fontSize: 12 } },
              h("div", null, h("span", { style: { color: TEXT3 } }, "KPIs: "), h("span", { style: { color: TEXT, fontWeight: 500 } }, s.kpis.join(", "))),
              h("div", null, h("span", { style: { color: TEXT3 } }, "Budget: "), h("span", { style: { color: TEXT, fontWeight: 500 } }, s.budget + "%")),
              h("div", { style: { gridColumn: "1/-1" } }, h("span", { style: { color: TEXT3 } }, "Creative: "), h("span", { style: { color: TEXT, fontWeight: 500 } }, s.creative))
            )
          );
        })
      )
    ),

    tab === "goals" && h("div", null,
      h("div", { style: Object.assign({}, card3d, { marginBottom: 16 }) },
        h("h3", { style: { fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 12 } }, "Add a Goal"),
        h("div", { style: { display: "flex", gap: 8, flexWrap: "wrap" } },
          h("select", { value: selStage, onChange: function(e) { setSelStage(e.target.value); }, style: { padding: "8px 12px", borderRadius: 8, border: "1px solid " + BORDER, fontSize: 13, color: TEXT, background: WHITE } },
            funnelStages.map(function(s) { return h("option", { key: s.key, value: s.key }, s.label); })
          ),
          h("input", { value: goalText, onChange: function(e) { setGoalText(e.target.value); }, onKeyDown: function(e) { if (e.key === "Enter") addGoal(); }, placeholder: "e.g. Reach 10K impressions this month", style: { flex: 1, minWidth: 200, padding: "8px 12px", borderRadius: 8, border: "1px solid " + BORDER, fontSize: 13, outline: "none", color: TEXT } }),
          h("button", { onClick: addGoal, style: { padding: "8px 20px", borderRadius: 999, background: PRIMARY, color: WHITE, border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer" } }, "Add")
        )
      ),
      goals.length === 0 && h("div", { style: Object.assign({}, card3d, { textAlign: "center", padding: 40 }) },
        h("svg", { width: 40, height: 40, viewBox: "0 0 24 24", fill: "none", stroke: TEXT3, strokeWidth: 1.5, style: { margin: "0 auto 12px" } },
          h("path", { d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" }),
          h("rect", { x: 9, y: 3, width: 6, height: 4, rx: 1 }),
          h("path", { d: "M9 14l2 2 4-4" })
        ),
        h("p", { style: { color: TEXT3, fontSize: 14 } }, "No goals yet. Add your first marketing goal above.")
      ),
      goals.length > 0 && h("div", { style: { display: "grid", gap: 10 } },
        goals.map(function(g) {
          var stage = funnelStages.find(function(s) { return s.key === g.stage; });
          return h("div", { key: g.id, onClick: function() { toggleGoal(g.id); }, style: Object.assign({}, card3d, { display: "flex", alignItems: "center", gap: 12, cursor: "pointer", opacity: g.done ? 0.6 : 1, borderLeft: "4px solid " + (stage ? stage.color : BORDER) }) },
            h("div", { style: { width: 22, height: 22, borderRadius: 6, border: g.done ? "none" : "2px solid " + BORDER, background: g.done ? PRIMARY : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 } },
              g.done && h("svg", { width: 14, height: 14, viewBox: "0 0 24 24", fill: "none", stroke: WHITE, strokeWidth: 3 }, h("path", { d: "M5 13l4 4L19 7" }))
            ),
            h("div", { style: { flex: 1 } },
              h("p", { style: { fontSize: 14, fontWeight: 500, color: TEXT, textDecoration: g.done ? "line-through" : "none" } }, g.text),
              h("span", { style: { fontSize: 11, color: stage ? stage.color : TEXT3, fontWeight: 600 } }, stage ? stage.label : "")
            )
          );
        })
      ),
      goals.length > 0 && h("div", { style: Object.assign({}, card3d, { marginTop: 16 }) },
        h("h3", { style: { fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 12 } }, "Goal Progress"),
        h(BarChart, { data: [
          { label: "Total", value: goals.length > 0 ? 100 : 0, color: BORDER },
          { label: "Done", value: goals.length > 0 ? Math.round(goals.filter(function(g) { return g.done; }).length / goals.length * 100) : 0, color: PRIMARY }
        ], width: 200, height: 140 })
      )
    ),

    tab === "recommendations" && h("div", null,
      !recs && !loading && h("div", { style: Object.assign({}, card3d, { textAlign: "center", padding: 40 }) },
        h("svg", { width: 40, height: 40, viewBox: "0 0 24 24", fill: "none", stroke: PRIMARY, strokeWidth: 1.5, style: { margin: "0 auto 12px" } },
          h("path", { d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" })
        ),
        h("p", { style: { color: TEXT3, fontSize: 14, marginBottom: 16 } }, "Let Vella analyze your funnel and give personalized recommendations."),
        h("button", { onClick: getRecs, style: { padding: "10px 28px", borderRadius: 999, background: PRIMARY, color: WHITE, border: "none", fontSize: 14, fontWeight: 600, cursor: "pointer" } }, "Get AI Recommendations")
      ),
      loading && h("div", { style: Object.assign({}, card3d, { textAlign: "center", padding: 40 }) },
        h("div", { style: { width: 36, height: 36, border: "3px solid " + BORDER, borderTopColor: PRIMARY, borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" } }),
        h("style", null, "@keyframes spin { to { transform: rotate(360deg); } }"),
        h("p", { style: { color: TEXT3, fontSize: 14 } }, "Vella is analyzing your objectives...")
      ),
      recs && h("div", null,
        h("div", { style: Object.assign({}, card3d, { boxShadow: SHADOW_LG }) },
          h("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 12 } },
            h("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: PRIMARY, strokeWidth: 2 },
              h("path", { d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" })
            ),
            h("h3", { style: { fontSize: 16, fontWeight: 700, color: TEXT } }, "Vella's Recommendations")
          ),
          h("div", { style: { fontSize: 14, color: TEXT, lineHeight: 1.7, whiteSpace: "pre-wrap" } }, recs)
        ),
        h("button", { onClick: getRecs, style: { marginTop: 12, padding: "8px 20px", borderRadius: 999, background: "transparent", color: PRIMARY, border: "1px solid " + PRIMARY, fontSize: 13, fontWeight: 600, cursor: "pointer" } }, "Refresh Recommendations")
      )
    )
  );
}

export default ObjectiveSelector;
